import { useState } from "react";
import { IOptionProps } from "./Option.props";
import { usePlanCreatorContext } from "@components/PlanCreator/PlanCreatorContext";

export const useOptionControl = (props: IOptionProps) => {
  const { disabled, readOnly } = usePlanCreatorContext();

  // const checkValue = (value?: string[]) => {
  //   if (!value) return undefined;
  //   if (!value[0].length) return undefined;
  //   return value;
  // };

  return {
    disabled,
    //checkValue,
    readOnly,
  };
};
